<template>
  <v-row>
    <v-col
      cols="12"
      md="6"
      lg="4"
    >
      <v-btn
        color="primary"
        @click.prevent="initAuthenticate"
      >
        Authenticate App
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ShopifySourceType',
  props: {
    storeName: {
      type: String,
      required: false,
      default: '',
    },
    clientId: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    async initAuthenticate() {
      const url = `${window.location.protocol}//${window.location.host}/finalizeOauth`;
      window.location.href = `https://${this.storeName}.myshopify.com/admin/oauth/authorize?client_id=${this.clientId}&scope=read_customers,read_inventory,read_locations,read_orders,read_products,read_all_orders&redirect_uri=${url}&state=${this.$route.query.t}`;
    },
  },
};
</script>
